type SessionEntry = {
    previousAssetId?: number;
    playbackSource?: string;
    wasViewed?: boolean;
    prevPosition?: number;
};

const session: Record<string, SessionEntry> = {};
export default session;
